/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Course settings service
 *
 * @file CourseSettingsService.js
 * @author Gladson Samuel S
 */


import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_SETTINGS_REQUESTED,
  HTTP_REQUEST_METHODS,
  COURSE_SETTINGS_FAILED,
  COURSE_SETTINGS_FETCHED
} from '../../../common/constants';

export default class CourseSettingsService extends BaseService {
  constructor() {
    super(COURSE_SETTINGS_REQUESTED, 'courseSettingsStatus');
  }

  /**
   * Handles course settings service event
   *
   * @param {*} eventName
   * @param {*} eventData
   * @returns
   */
  handleEvent(eventName, eventData) {
    const {
      method = HTTP_REQUEST_METHODS.GET,
      payload,
      courseId
    } = eventData;

    let request = null;

    switch (method) {
      case HTTP_REQUEST_METHODS.PATCH:
        request = this.getClient('marin')
          .patch(`/courses/${courseId}/settings`, payload);
        break;
      case HTTP_REQUEST_METHODS.PUT:
        request = this.getClient('marin')
          .put(`/courses/${courseId}/settings`, payload);
        break;
      default:
        request = this.getClient('marin').get(`/courses/${courseId}/settings`);
        break;
    }

    return request;
  }

  /**
  * Handles course settings service response
   *
   * @param {*} response
   */
  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, event) {
    const { callback } = event;

    if (typeof callback === 'function') {
      callback();
    }

    const { data } = response;
    const bookshelf = Framework.getStoreRegistry().getStore('bookshelf');
    bookshelf.setCourseSettings(data, event.courseId);

    Framework.getEventManager().publish(COURSE_SETTINGS_FETCHED, {
      data
    });
  }

  /**
   * Handles course settings service error
   *
   * @param {*} response
   */
  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_SETTINGS_FAILED, error);
    // eslint-disable-next-line no-console
    console.log(error, 'Course settings service error');
  }
}
